import React from 'react';

export default class Landing extends React.Component {
    render() {
        return <div className="vl-landing vulners-landing-wrapper"></div>;
    }
}

Landing.LS_LANDING_SHOW = 'vulners_landing_show';
Landing.LS_LANDING_VISITED = 'vulners_landing_visited';
